// libraries.
import { robotoRegular } from '@habitech/shared';
import styled from 'styled-components';

export const WrapperInProgressStepsCards = styled.div`
  .card-sub-title {
    font-size: 14px;
    font-family: ${robotoRegular};
  }
`;
